var persianNumbers = [
  /۰/g,
  /۱/g,
  /۲/g,
  /۳/g,
  /۴/g,
  /۵/g,
  /۶/g,
  /۷/g,
  /۸/g,
  /۹/g,
]
var arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]

function fixNumbers(str) {
  if (typeof str === 'string') {
    for (var i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i)
    }
  }
  return str
}

function toDateFormat(date) {
  var strDate = ''
  if (typeof date === 'string') {
    var d = fixNumbers(date).split('/')
    var day = parseInt(d[2])
    var month = parseInt(d[1])
    var year = parseInt(d[0])
    strDate =
      year +
      '/' +
      (month > 9 ? '' : '0') +
      month +
      '/' +
      (day > 9 ? '' : '0') +
      day
  }

  return strDate
}

function toTimeFormat(time) {
  var strDate = ''
  if (typeof time === 'string') {
    var d = fixNumbers(time)
    d = d.split(':')
    var second = parseInt(d[2])
    var min = parseInt(d[1])
    var hour = parseInt(d[0])

    strDate =
      (hour > 9 ? '' : '0') +
      hour +
      ':' +
      (min > 9 ? '' : '0') +
      min +
      ':' +
      (second > 9 ? '' : '0') +
      second
  }

  return strDate
}
function setComma(x) {
  return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

function extractNumber(x) {
  try {
    if (x === null) return ''
    var d = fixNumbers(x)
    var numberPattern = /\d+/g
    return d.match(numberPattern).join('')
  } catch (e) {
    console.log(e)
  }
}

function stripHtmlTags(str) {
  if (str === null || str === '') return false
  else str = str.toString()
  return str.replace(/<[^>]*>/g, '')
}

module.exports = {
  fixNumbers,
  toDateFormat,
  setComma,
  toTimeFormat,
  extractNumber,
  stripHtmlTags,
}
